const Flyer = ({ amount }) => {
  return (
    <div
      className="w-24 bg-red-600 h-16 -rotate-45 rounded-md z-10 absolute flex justify-center items-end p-1"
      style={{ left: '-2.5rem', top: '-1.5rem' }}
    >
      <span className="text-white">{amount}</span>
    </div>
  );
};

export default Flyer;
